<div class="modal-content custom-modal">
  <!-- <div class="header">
    <h2>
      Email Alerts
      <span class="infoIcon">
        <mat-icon
          [matTooltip]="'This setting will not be effective retro-effectively'"
        >
          info
        </mat-icon>
      </span>
    </h2>
  </div> -->

  <div class="alert-container">
    <!-- HEADER ROW -->
    <div class="alert-row header-row">
      <div class="left-header">Alerts</div>
      <div class="center-header">Value</div>
      <div class="right-header">Email</div>
    </div>

    <!-- Row 1 -->
    <div class="alert-row">
      <mat-checkbox
        [(ngModel)]="alerts.instructedSpeed.app"
        (change)="onAppToggleChange('instructedSpeed')"
        color="primary"
      
      ></mat-checkbox>

      <div class="left">
        <div class="title">Instructed Speed Alert</div>
        <div class="subtitle">
          Send email when current speed falls below or above instructed speed(+/- {{ instructedDeltaValue }} knots)
        </div>
      </div>
         <div class="center">
        <input
          type="number"
          [(ngModel)]="instructedDeltaValue"
        />
        <span class="unitT">knots</span>
      </div>

      <mat-slide-toggle
        [(ngModel)]="alerts.instructedSpeed.email"
        [disabled]="
          !alerts.instructedSpeed.app
        "
      ></mat-slide-toggle>
    </div>

    <!-- Row 2 -->
    <div class="alert-row">
      <mat-checkbox
        [(ngModel)]="alerts.thresholdSpeed.app"
        (change)="onAppToggleChange('thresholdSpeed')"
        color="primary"
        
      ></mat-checkbox>

      <div class="left">
        <div class="title">Threshold Speed Alert</div>
        <div class="subtitle">
          Send email when current speed falls below threshold ({{
            thresholdValue
          }}
          knots)
        </div>
      </div>
      <div class="center">
        <input
          type="number"
          [(ngModel)]="thresholdValue"
          
        />
        <span class="unitT">knots</span>
      </div>
      <div class="right">
        <!-- Input Value Container -->

        <!-- Email Toggle Container -->
        <div class="toggle-container">
          <mat-slide-toggle
            [(ngModel)]="alerts.thresholdSpeed.email"
            [disabled]="
              !alerts.thresholdSpeed.app 
            "
          ></mat-slide-toggle>
        </div>
      </div>
    </div>

    <!-- Row 3 -->
    <div class="alert-row">
      <mat-checkbox
        [(ngModel)]="alerts.deviation.app"
        (change)="onAppToggleChange('deviation')"
        color="primary"
       
      ></mat-checkbox>

      <div class="left">
        <div class="title">Deviation Alert</div>
        <div class="subtitle">
          Send email when the vessel deviates from the route ({{
            deviationValue
          }}
          nm)
        </div>
      </div>
      <div class="center">
        <input
          type="number"
          [(ngModel)]="deviationValue"
          
        />
        <span class="unitD">nm</span>&nbsp;&nbsp;
      </div>
      <div class="right">
        <div class="toggle-container">
          <mat-slide-toggle
            [(ngModel)]="alerts.deviation.email"
            [disabled]="
              !alerts.deviation.app 
            "
          ></mat-slide-toggle>
        </div>
      </div>
    </div>
  </div>

  <div class="footer">
    <button
      class="save-btn"
      (click)="saveAlerts()"
      [disabled]="username !== 'Meraki - Operations'"
    >
      Save
    </button>
  </div>
</div>
